import { useEffect } from "react";
import { createContext } from "react";
import { verifyToken } from "../../utils/apotamentos";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext({});

export const AuthProviders = ({ children }) => {
    const navigate = useNavigate();

    const token = localStorage.getItem("@token");
    const userdata = JSON.parse(localStorage.getItem("@userdata"));

    useEffect(() => {
        if (!verifyToken(token, navigate)) {
            return;
        }
    }, []);

    return (
        <AuthContext.Provider
            value={{
                token, 
                userdata
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
